<template>
  <div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import triggerBaseMixin from '../mixins/trigger-base-mixin';

  export default Vue.extend({
    mixins: [triggerBaseMixin],
  });
</script>